export default function (ctx) {
  const loggedIn = ctx.app.$cookies.get('auth-token')
  return loggedIn ? true : ctx.redirect(ctx.app.localePath('/'))
}
